import React, { useContext } from "react";
import { Context, Hooks, XtLocale, Cookie, Request, Config, Util, isRtlLocale } from "@xt/xtbase";
import logo from "./landing-logo.png";
import IconXiala01 from "../../../../@xt/Nav/src/img/icon/xiala-01";
import styles from "./index.module.less";

const { XtContext } = Context;
const { useTranslation } = Hooks;
const { setHeader } = Request;
const { getUrl } = Util;

/**
 * 落地页专用顶栏（对齐 Figma Home 顶栏：#181a20 60px，左 Logo，右 Download + 语言/计价）
 */
export default function LandingNav() {
  const intl = XtLocale.intl;
  const [appState, appDispatch] = useContext(XtContext);
  const { lang, currency } = appState;
  const rtl = isRtlLocale(lang);
  const t = useTranslation();
  const langAry = XtLocale.localeList;
  const langCode = intl.code;

  const handleLangChange = (obj) => {
    if (obj.key === intl.locale) return;
    Cookie.set("lang", obj.code);
    Cookie.set("langManual", "1");
    setHeader({ lang: obj.code });
    appDispatch({ payload: { lang: obj.key } });
    const langPath = XtLocale.getLangPath();
    if (langPath) location.href = "/" + obj.key + XtLocale.getLeftPath();
    else location.reload();
  };

  const handleAssistChange = (obj) => {
    Cookie.set("currency", obj.key);
    appDispatch({ payload: { currency: obj.key } });
  };

  const currentLang = langAry.find((item) => lang === item.key);
  const assist = Config.assistConfig.find((item) => currency === item.key) || { name: "USD" };
  const langCurrencyLabel = `${currentLang ? currentLang.lab : "English"}/${assist.name}`;

  return (
    <header className={`${styles.landingNav} ${rtl ? styles.landingNavRtl : ""}`} lang={langCode}>
      <div className={styles.inner}>
        <a href={getUrl("/")} className={styles.logoLink} aria-label="Spikex">
          <img src={logo} alt="" className={styles.logo} />
        </a>
        <div className={styles.right}>
          <a href={getUrl("/app")} className={styles.downloadLink}>
            {t("header.download")}
          </a>
          <div className={`${styles.iDrop} ${styles.iLang}`}>
            <button type="button" className={styles.langTrigger} aria-haspopup="true" aria-expanded="false">
              <span className={styles.langTriggerText}>{langCurrencyLabel}</span>
              <IconXiala01 className={styles.chevron} />
            </button>
            <div className={styles.dropdown}>
              <div className={styles.dropdownCol}>
                <span className={styles.dropdownHeading}>{t("header.lang")}</span>
                {langAry.map((item) => (
                  <a
                    key={item.key}
                    href="#"
                    className={lang === item.key ? styles.atv : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleLangChange(item);
                    }}
                  >
                    {item.lab}
                  </a>
                ))}
              </div>
              <div className={styles.dropdownCol}>
                <span className={styles.dropdownHeading}>{t("header.currency")}</span>
                {Config.assistConfig.map((item) => (
                  <a
                    key={item.key}
                    href="#"
                    className={currency === item.key ? styles.atv : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      handleAssistChange(item);
                    }}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
